var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVerified(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.097,
    height: 17.126,
    viewBox: "0 0 17.097 17.126",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1338",
    "data-name": "Group 1338",
    transform: "translate(-946.697 -487.307)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_183",
    "data-name": "Path 183",
    d: "M954.747,487.307h1c.225.027.452.05.676.082a8.559,8.559,0,0,1,7.238,7.008c.056.322.088.648.131.972v1c-.01.059-.023.118-.03.177-.041.309-.064.621-.122.927a8.555,8.555,0,0,1-6.921,6.826c-.322.056-.648.089-.972.132h-1c-.049-.01-.1-.021-.146-.029-.466-.072-.94-.111-1.4-.221a8.571,8.571,0,0,1-6.353-9.917,8.419,8.419,0,0,1,2.319-4.412,8.33,8.33,0,0,1,4.6-2.416C954.1,487.383,954.423,487.35,954.747,487.307Zm.516,1a7.56,7.56,0,1,0,7.53,7.579A7.564,7.564,0,0,0,955.263,488.311Z",
    fill: "#55bc28"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_184",
    "data-name": "Path 184",
    d: "M1053.277,627.575a1.931,1.931,0,0,1,.144-.191q2.093-2.1,4.191-4.193a.859.859,0,0,1,.377-.218.428.428,0,0,1,.48.224.475.475,0,0,1-.017.549,1.079,1.079,0,0,1-.133.149l-4.613,4.622a.527.527,0,0,1-.874,0q-1.269-1.27-2.538-2.54a.539.539,0,0,1-.192-.522.494.494,0,0,1,.772-.3,1.265,1.265,0,0,1,.161.145q1.051,1.051,2.1,2.1C1053.177,627.44,1053.211,627.492,1053.277,627.575Z",
    transform: "translate(-99.07 -129.98)",
    fill: "#55bc28"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerified);
export default __webpack_public_path__ + "static/media/verified.2a21e6064d8e6939bcaaaa38b06f5481.svg";
export { ForwardRef as ReactComponent };